import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-end" }
const _hoisted_3 = { class: "flex flex-col items-start" }
const _hoisted_4 = { class: "font-semibold text-gray-700 break-words" }
const _hoisted_5 = { class: "text-sm text-gray-500" }

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import EmptyState from '@/components/neue/EmptyState.vue'
import NeueButton from '@/components/neue/NeueButton.vue'
import NeueLoading from '@/components/neue/NeueLoading.vue'
import NeueTablist from '@/components/neue/NeueTablist.vue'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import TablistHeader from '@/components/neue/TablistHeader.vue'
import TablistRow from '@/components/neue/TablistRow.vue'
import { NEW_ROLE, rolePath } from '@/config/settingsTabs'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'
import { mapRelationships, mapType } from '@/store/mappers'
import SettingsShell from '@/view/settings/SettingsShell.vue'

const EMPTY_CARD = 'rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm text-center'


export default {
  __name: 'Roles',
  setup(__props) {

const router = useRouter()
const store = useStore()

const isConvertedToEmail = computed(() => !!store.state.loggedInUser?.attributes?.converted_to_email_signin)

const rolesCols = [
  { width: 'minmax(120px, 1fr)' }, // Name
  { width: '120px' } // "+ Role" action button
]

const canCreateSystemUsers = computed(() => privilegeService.canAccessResourceAction('system_users', null, 'create'))
const canReadSystemUsers = computed(() => privilegeService.canAccessResourceAction('system_users', null, 'read'))
const roles = computed(() => mapType('system_user_role'))
const loading = ref(true)

const getUserCount = role => {
  return mapRelationships(role.relationships?.system_users?.data || []).length
}

onMounted(() => {
  if (canReadSystemUsers.value) {
    api.call('GET', 'system_user_roles?included=system_users,system_user_privileges').then(() => {
      loading.value = false
    })
  } else {
    loading.value = false
  }
})

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(SettingsShell, null, {
    default: _withCtx(() => [
      _createVNode(SettingsSection, {
        title: "Roles",
        description: "Roles control what each team member can see and do. Give a role the permissions it needs, like viewing reports, editing settings or managing users, then invite your team to it.",
        plain: ""
      }, {
        default: _withCtx(() => [
          _createVNode(NeueLoading, { loading: loading.value }, {
            default: _withCtx(() => [
              (roles.value.length && canReadSystemUsers.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(NeueTablist, null, {
                      head: _withCtx(() => [
                        _createVNode(TablistHeader, null, {
                          default: _withCtx(() => [
                            _createVNode(TablistGrid, {
                              columns: rolesCols,
                              header: "",
                              class: "items-center"
                            }, {
                              default: _withCtx(() => [
                                _cache[1] || (_cache[1] = _createElementVNode("div", null, "Name", -1)),
                                _createElementVNode("div", _hoisted_2, [
                                  (canCreateSystemUsers.value)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        to: _unref(NEW_ROLE)
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(NeueButton, { type: "primary" }, {
                                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                              _createTextVNode("+ Role", -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["to"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (role) => {
                          return (_openBlock(), _createBlock(TablistRow, {
                            key: role.id,
                            class: _normalizeClass(["transition-colors", canReadSystemUsers.value ? 'cursor-pointer' : 'cursor-not-allowed opacity-50']),
                            onClick: $event => (canReadSystemUsers.value && _unref(router).push(_unref(rolePath)(role.id)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(TablistGrid, { columns: rolesCols }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("span", _hoisted_4, _toDisplayString(role.attributes.name), 1),
                                    _createElementVNode("span", _hoisted_5, _toDisplayString(getUserCount(role)) + " " + _toDisplayString(getUserCount(role) === 1 ? 'user' : 'users'), 1)
                                  ]),
                                  _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
                : (!canReadSystemUsers.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(EMPTY_CARD)
                    }, [
                      _createVNode(EmptyState, { plural: "roles" })
                    ]))
                  : (!isConvertedToEmail.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass(EMPTY_CARD)
                      }, [
                        _createVNode(EmptyState, {
                          plural: "users or roles",
                          description: "Set up email sign-in to invite team members and control what each of them can access."
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, { to: "/confirm-email-address" }, {
                              default: _withCtx(() => [
                                _createVNode(NeueButton, { type: "primary" }, {
                                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                    _createTextVNode("Set up email sign-in", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 3,
                        class: _normalizeClass(EMPTY_CARD)
                      }, [
                        _createVNode(EmptyState, { plural: "roles" }),
                        (canCreateSystemUsers.value)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: _unref(NEW_ROLE),
                              class: "mt-4 inline-block"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(NeueButton, { type: "primary" }, {
                                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                    _createTextVNode("+ Role", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

}